import { useQuery } from '@tanstack/react-query';
import { fetchQuizReattempts } from '../services/subscriptionService';

export function useQuizReattempts() {
  return useQuery({
    queryKey: ['quizReattempts'],
    queryFn: async () => {
      const data = await fetchQuizReattempts();
      return {
        remainingAttempts: Number(data.remaining_attempts || 0),
        packs: (Array.isArray(data.reattempt_prices) ? data.reattempt_prices : [])
          .filter((pack) => Number(pack?.status) === 1),
      };
    },
    staleTime: 0,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  });
}
